import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=b5a4f328&scoped=true"
import script from "./CurrencyList.vue?vue&type=script&lang=js"
export * from "./CurrencyList.vue?vue&type=script&lang=js"
import style0 from "./CurrencyList.vue?vue&type=style&index=0&id=b5a4f328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a4f328",
  null
  
)

export default component.exports